export const getSubdomain = () => {
    const parts: string[] = window.location.hostname
        .replace("www.", "")
        .split(".");
    // subdomain exists only if there are at least 3 parts (foo.qb.live / foo.votebox.live)
    return parts.length > 2 ? parts[0] : undefined;
};

export const getUrl = (): string => {
    const subdomain = getSubdomain();
    if (subdomain) {
        return window.env.REACT_APP_ONLINE_API_BASE_URL.replace(
            "https://",
            `https://${subdomain}.`,
        );
    } else {
        return window.env.REACT_APP_ONLINE_API_BASE_URL;
    }
};
